<template>
    <div>
        <div v-if="!loading">
            <Login v-if="!auth" />
            <div v-else class="admin-layout">
                <Agreement
                    v-if="settings && settings.accept_agreement !== '1'"
                />
                <Nav class="admin-layout__header" />
                <div class="admin-layout__content" :style="contentStyle">
                    <Sidebar
                        class="admin-layout__sidebar"
                        :menu-panel-open="menuPanelOpen"
                        :menu-section="menuSection"
                        @open-menu-section="openMenuSection"
                        @close-menu-panel="closeMenuPanel"
                    />
                    <div class="flex-1 router-view">
                        <UpdateInfo :routeNameProps="$route.name" />
                        <router-view :key="$route.fullPath"></router-view>
                    </div>
                </div>
                <SystemInfoBar />
            </div>
        </div>
        <Loading v-else class="mt-6 ml-6" />
        <UpdateModal v-if="platformUpdating"></UpdateModal>
    </div>
</template>
<script>
import Nav from "./Admin/Nav";
import Sidebar from "./Admin/Sidebar";
import SystemInfoBar from "./Admin/SystemInfoBar.vue";
import Agreement from "./Admin/Agreement";
import Login from "./Admin/Login.vue";
import UpdateModal from "./Admin/Updates/UpdateModal";

export default {
    name: "Admin",
    components: { Sidebar, Nav, SystemInfoBar, Agreement, Login, UpdateModal },
    computed: {
        settings() {
            return this.$store.state.settings.settings;
        },
        contentStyle() {
            const sidebarWidth = 55;

            return {
                paddingTop: "55px",
                paddingLeft: `${sidebarWidth}px`,
            };
        },
        platformUpdating() {
            return this.$store.state.versions.updatingProgress &&
                this.$store.state.versions.updatingProgress.processing &&
                parseInt(
                    this.$store.state.versions.updatingProgress.processing
                ) === 1
                ? true
                : false;
        },
    },
    data() {
        return {
            auth: false,
            loading: false,
            menuPanelOpen: false,
            menuSection: null,
        };
    },
    created() {
        this.getAuth();
    },
    methods: {
        async getAuth() {
            this.loading = true;
            try {
                const res = await axios.get("/api/admin/me");
                this.auth = res.data;
            } catch (error) {
                // console.log(error);
            } finally {
                this.loading = false;
            }
        },
        openMenuSection(section) {
            this.menuSection = section;
            this.menuPanelOpen = true;
        },
        closeMenuPanel() {
            this.menuPanelOpen = false;
        },
    },
};
</script>
<style scoped>
.admin-layout__content {
    display: flex;
}
.router-view {
    padding-bottom: 96px;
}
</style>
